import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { WarningIcon } from "../../../../components/icons";

const ErrorModal = ({
    text = "An error occurred. Please try again.",
    handleClose,
    show,
}) => {
    if (!show) return null;

    return (
        <>
            <div className="tw:fixed tw:inset-0 tw:bg-black tw:bg-opacity-50"></div>
            <div
                className="tw:fixed tw:inset-0 tw:z-50 tw:flex tw:items-center tw:justify-center"
                role="dialog"
            >
                <div
                    className="tw:max-w-lg tw:w-full tw:mx-auto"
                    role="document"
                >
                    <div className="tw:bg-white tw:rounded-lg tw:shadow-lg tw:border-t-4 tw:border-red-500">
                        <div className="tw:absolute tw:top-4 tw:right-4">
                            <button
                                onClick={handleClose}
                                type="button"
                                className="tw:text-gray-500 tw:hover:text-gray-700"
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>
                        <div className="tw:p-6 tw:text-center">
                            <div className="tw:mb-4">
                                <WarningIcon width={64} height={64} color="#ED553B" />
                            </div>
                            <div className="tw:text-red-500 tw:text-xl tw:font-medium">
                                {text}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ErrorModal;